{
  "auth": {
    "agree": "Acepto",
    "createAccount": "Crear cuenta",
    "createNewAccount": "Crear cuenta nueva",
    "email": "Email",
    "login": "Iniciar sesión",
    "password": "Contraseña",
    "recover_password": "Recuperar contraseña",
    "sign_up": "Registrar",
    "keep_logged_in": "Mantenerme conectado",
    "termsOfUse": "Términos de uso",
    "reset_password": "Restablecer contraseña"
  },
  "404": {
    "title": "Esta página se ha ido a pescar",
    "text": "Si crees que esto no es correcto, por favor envíanos un mensaje a ",
    "back_button": "Volver al tablero"
  },
  "typography": {
    "primary": "Estilos de texto primarios",
    "secondary": "Estilos de texto secundarios"
  },
  "dashboard": {
    "versions": "Versiones",
    "setupRemoteConnections": "Configurar conexiones remotas",
    "currentVisitors": "Visitantes actuales",
    "charts": {
      "trendyTrends": "Tendencias modernas",
      "showInMoreDetail": "Mostrar en más detalle",
      "showInLessDetail": "Mostrar en menos detalle",
      "loadingSpeed": "Velocidad de carga",
      "topContributors": "Principales contribuyentes",
      "showNextFive": "Mostrar los siguientes cinco",
      "commits": "Commit"
    },
    "info": {
      "componentRichTheme": "Tema rico en componentes",
      "completedPullRequests": "Solicitudes de pull completadas",
      "users": "Usuarios",
      "points": "Puntos",
      "units": "Unidades",
      "exploreGallery": "Explorar galería",
      "viewLibrary": "Ver biblioteca",
      "commits": "Commits",
      "components": "Componentes",
      "teamMembers": "Miembros del equipo"
    },
    "tabs": {
      "overview": {
        "title": "Visión general",
        "built": "Construido con el framework Vue.js",
        "free": "Totalmente gratuito para todos",
        "fresh": "Diseño fresco y nítido",
        "mobile": "Responsivo y optimizado para móviles",
        "components": "Toneladas de componentes útiles",
        "nojQuery": "Totalmente libre de jQuery"
      },
      "billingAddress": {
        "title": "Dirección de facturación",
        "personalInfo": "Información personal",
        "firstName": "Nombre y apellido",
        "email": "Email",
        "address": "Dirección",
        "companyInfo": "Información de la empresa",
        "city": "Ciudad",
        "country": "País",
        "infiniteConnections": "Conexiones infinitas",
        "addConnection": "Añadir conexión"
      },
      "bankDetails": {
        "title": "Detalles del banco",
        "detailsFields": "Campos de detalles",
        "bankName": "Nombre del banco",
        "accountName": "Nombre de la cuenta",
        "sortCode": "Código de ordenación",
        "accountNumber": "Número de cuenta",
        "notes": "Notas",
        "sendDetails": "Enviar detalles"
      }
    },
    "navigationLayout": "Diseño de navegación",
    "topBarButton": "Barra superior",
    "sideBarButton": "Barra lateral"
  },
  "language": {
    "brazilian_portuguese": "Portugués brasileño",
    "english": "Inglés",
    "spanish": "Español",
    "simplified_chinese": "Chino simplificado",
    "persian": "Persa"
  },
  "menu": {
    "auth": "Autenticación",
    "buttons": "Botones",
    "timelines": "Líneas de tiempo",
    "dashboard": "Tablero",
    "billing": "Ventas",
    "login": "Iniciar sesión",
    "preferences": "Preferencias",
    "payments": "Pagos",
    "pricing-plans": "Planes de precios",
    "login-singup": "Iniciar sesión/Registrarse",
    "404": "Páginas 404",
    "faq": "FAQ",
    "clients": "Clientes",
    "sales": "Ventas",
    "finance": "Finanzas",
    "financeDashboard": "Panel de Finanzas",
    "financialReports": "Reportes Financieros",
    "activeUsers": "Usuarios Activos",
    "staff": "Personal",
    "invitations": "Invitaciones",
    "setup": "Configuración",
    "items": "Artículos",
    "roles": "Roles",
    "configurations": "Configuraciones",
    "inventory": "Inventario",
    "inventoryDashboard": "Tablero",
    "inventoryItems": "Artículos de inventario",
    "inventoryLocations": "Ubicaciones de inventario",
    "stockIn": "Entrada de stock",
    "stockOut": "Salida de inventario",
    "transfers": "Transferencias",
    "procurement": "Adquisiciones",
    "suppliers": "Proveedores",
    "expenses": "Gastos",
    "commissions": "Comisiones",
    "catalog": "Catálogo",
    "products": "Productos",
    "unitsOfMeasure": "Unidades de medida",
    "servicesCatalog": "Servicios",
    "salesOrders": "Pedidos de venta",
    "invoices": "Facturas",
    "financeOverview": "Resumen",
    "financePayments": "Pagos",
    "transactions": "Transacciones",
    "reports": "Informes",
    "financeReports": "Informes financieros",
    "itemsReports": "Artículos",
    "usersAndRoles": "Usuarios y roles",
    "systemUsers": "Usuarios activos",
    "rolesAndPermissions": "Roles y permisos",
    "settingsApplication": "Ajustes",
    "companySettings": "Datos de la empresa"
  },
  "messages": {
    "all": "Ver todos los mensajes",
    "new": "Nuevos mensajes de {name}",
    "mark_as_read": "Marcar como leído"
  },
  "navbar": {
    "messageUs": "Preguntas sobre desarrollo web:",
    "repository": "Repositorio GitHub"
  },
  "notifications": {
    "all": "Ver todas las notificaciones",
    "mark_as_read": "Marcar como leída",
    "sentMessage": "{name} te envió un mensaje",
    "uploadedZip": "{name} subió un archivo Zip con {type}",
    "startedTopic": "{name} inició un nuevo tema"
  },
  "user": {
    "language": "Cambiar Idioma",
    "logout": "Cerrar sesión",
    "profile": "Mi Perfil",
    "settings": "Configuración",
    "billing": "Ventas",
    "faq": "Preguntas Frecuentes",
    "helpAndSupport": "Ayuda & Soporte",
    "projects": "Proyectos",
    "account": "Cuenta",
    "explore": "Explorar"
  },
  "helpAndSupport": "Ayuda y Soporte",
  "aboutVuesticAdmin": "Acerca de Vuestic Admin",
  "search": {
    "placeholder": "Buscar..."
  },
  "expense": {
    "tabs": {
      "expenses": "Gastos",
      "expenseItems": "Partidas de gasto",
      "expenseCategories": "Categorías de gasto"
    },
    "recordsPlaceholder": "Los registros de gastos estarán disponibles en esta pestaña en un cambio aparte.",
    "records": {
      "registrationHeading": "Cabecera del gasto",
      "referenceNumber": "Número de referencia",
      "expenseDate": "Fecha del gasto",
      "totalAmount": "Importe total",
      "notes": "Notas",
      "linesHeading": "Líneas del gasto",
      "addLineHeading": "Añadir línea de gasto",
      "linesEmptyState": "No hay líneas de gasto. Use el formulario de arriba para añadirlas.",
      "removeLineConfirmTitle": "Eliminar línea",
      "removeLineConfirmMessage": "¿Seguro que desea eliminar esta línea de gasto?",
      "removeLineConfirmOk": "Eliminar",
      "linesCountSuffix": "línea(s)",
      "selectCategory": "Seleccione categoría",
      "selectExpenseItem": "Seleccione partida de gasto",
      "validationSelectCategory": "Seleccione una categoría de gasto.",
      "validationSelectItem": "Seleccione una partida de gasto.",
      "validationAmountRequired": "El importe es obligatorio.",
      "validationAmountPositive": "El importe debe ser mayor que cero.",
      "validationDescriptionRequired": "La descripción es obligatoria.",
      "validationFixLine": "Corrija los datos de la línea antes de añadir.",
      "addLine": "Añadir línea",
      "submit": "Registrar gasto",
      "submitConfirmTitle": "Confirmar gasto",
      "submitConfirmMessage": "¿Registrar este gasto por {total} con {count} línea(s)?",
      "submitConfirmOk": "Registrar gasto",
      "expenseItem": "Partida de gasto",
      "amount": "Importe",
      "displayDetailed": "Detallado",
      "displaySummary": "Resumen",
      "registerExpense": "Registrar gasto",
      "search": "Buscar",
      "filterExpenseNumber": "Número de gasto",
      "filterReferenceNumber": "Número de referencia",
      "filterStartDate": "Desde la fecha",
      "filterEndDate": "Hasta la fecha",
      "applyFilters": "Aplicar filtros",
      "clearFilters": "Borrar",
      "expenseNumber": "Número de gasto",
      "viewDetails": "Ver detalles",
      "resultsSuffix": "resultados.",
      "perPage": "Por página",
      "listLoadFailed": "No se pudieron cargar los gastos. Inténtelo de nuevo.",
      "listEmptySummary": "No se encontraron gastos para los filtros actuales.",
      "listEmptyDetailed": "No se encontraron líneas de gasto para los filtros actuales.",
      "saveFailed": "No se pudo guardar el gasto. Inténtelo de nuevo.",
      "noDetail": "No hay detalles del gasto disponibles."
    },
    "statusActive": "Activo",
    "statusInactive": "Inactivo",
    "yes": "Sí",
    "no": "No",
    "modal": {
      "createExpenseItem": "Crear partida de gasto",
      "editExpenseItem": "Editar partida de gasto",
      "createExpenseCategory": "Crear categoría de gasto",
      "editExpenseCategory": "Editar categoría de gasto",
      "registerExpense": "Registrar gasto",
      "expenseLinesTitle": "Líneas del gasto"
    },
    "columns": {
      "name": "Nombre",
      "code": "Código",
      "description": "Descripción",
      "status": "Estado",
      "category": "Categoría",
      "defaultAmount": "Importe por defecto",
      "item": "Partida"
    },
    "form": {
      "expenseCategory": "Categoría de gasto",
      "name": "Nombre",
      "code": "Código",
      "defaultAmount": "Importe por defecto",
      "description": "Descripción",
      "active": "Activo",
      "save": "Guardar",
      "cancel": "Cancelar"
    },
    "categoriesLoadFailed": "No se pudieron cargar las categorías de gasto. Inténtelo de nuevo.",
    "itemsLoadFailed": "No se pudieron cargar las partidas de gasto. Inténtelo de nuevo.",
    "validation": {
      "atLeastOneLine": "Añada al menos una línea de gasto.",
      "expenseDateRequired": "La fecha del gasto es obligatoria.",
      "expenseDateNotInFuture": "La fecha del gasto no puede ser posterior a hoy.",
      "totalMustBePositive": "El importe total debe ser mayor que cero."
    },
    "toasts": {
      "categoryCreated": "Categoría de gasto creada correctamente",
      "categoryUpdated": "Categoría de gasto actualizada correctamente",
      "categoryDeleted": "Categoría de gasto eliminada correctamente",
      "itemCreated": "Partida de gasto creada correctamente",
      "itemUpdated": "Partida de gasto actualizada correctamente",
      "itemDeleted": "Partida de gasto eliminada correctamente",
      "expenseCreated": "Gasto registrado correctamente"
    }
  },
  "inventoryHealth": {
    "pageTitle": "Panel de inventario",
    "pageSubtitle": "Problemas de stock y caducidad que requieren atención.",
    "pageSubtitleAtLocation": "Problemas de stock y caducidad que requieren atención en {location}.",
    "asOfDate": "Al {date}",
    "permissionDenied": "No tiene permiso para ver los conteos de salud del inventario.",
    "selectWarehouse": "Seleccione un almacén para ver los conteos de salud del inventario de esa ubicación.",
    "loadError": "No se pudieron cargar los conteos de salud del inventario.",
    "retry": "Reintentar",
    "allClear": "No hay problemas de stock bajo ni de caducidad en esta ubicación.",
    "allItems": "Todos los artículos",
    "filterToolbarAria": "Filtros de stock y caducidad",
    "stockSection": "Stock",
    "expirySection": "Caducidad",
    "cardClear": "Sin problemas",
    "cardAlert": "Atención",
    "attentionSummary": "artículos requieren atención",
    "badgeNeedsAttention": "Requiere atención",
    "badgePlanAction": "Planificar",
    "badgeTakeAction": "Actuar",
    "lowStock": "Stock bajo",
    "lowStockSubtitle": "Artículos en o por debajo del nivel de reorden",
    "outOfStock": "Sin stock",
    "outOfStockSubtitle": "No hay stock disponible en esta ubicación",
    "inStock": "En stock",
    "expiringSoon": "Por caducar",
    "expiringSoonSubtitle": "Lotes en la ventana de alerta de caducidad",
    "expiringSoonSubtitleDays": "Lotes que caducan en {days} días",
    "expired": "Caducado",
    "expiredSubtitle": "Artículos con lotes caducados",
    "expiredSubtitleBatches": "{count} lotes caducados en {location}",
    "viewLowStock": "Ver artículos con stock bajo",
    "viewOutOfStock": "Ver artículos sin stock",
    "viewExpiring": "Ver artículos por caducar",
    "viewExpired": "Ver artículos caducados",
    "glanceTitle": "Inventario de un vistazo",
    "totalItems": "Total de artículos",
    "totalItemsSubtitle": "En todas las categorías",
    "totalBatches": "Total de lotes",
    "totalBatchesSubtitle": "Lotes activos",
    "totalLocations": "Total de ubicaciones",
    "totalLocationsSubtitle": "Ubicaciones de stock activas",
    "totalLocationsSubtitleNamed": "{location}",
    "totalLocationsSubtitleOthers": "{location} + {count} más",
    "itemsInStock": "Artículos en stock",
    "itemsInStockSubtitle": "{percent}% del total de artículos",
    "stockBreakdownTitle": "Desglose de stock",
    "totalIssues": "Problemas totales",
    "quickActionsTitle": "Acciones rápidas",
    "quickActionAdjustStock": "Ajustar stock",
    "quickActionViewReports": "Ver informes",
    "quickActionManageItems": "Administrar artículos",
    "quickActionStockIn": "Entrada de stock",
    "quickActionCreatePurchaseOrder": "Crear orden de compra",
    "focusHintExpired": "Los lotes caducados están resaltados.",
    "focusHintExpiringSoon": "Los lotes por caducar están resaltados.",
    "stockByLocationEmpty": "No se devolvió stock por ubicación para este artículo.",
    "stockByLocationLoadError": "No se pudo cargar el stock por ubicación.",
    "viewItems": "Ver artículos",
    "cardAria": "{label}: {count}. Abrir artículos filtrados."
  }
}
